/**
 * Created by user on 2020/5/11.
 */

export * from '@novel-segment/dict-loader-core';
import { LoaderClass } from '@novel-segment/dict-loader-core';

export default LoaderClass
